export default __webpack_public_path__ + "static/media/locationMarker.02f0bdda.svg";